var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M2.708 10.165c0-1.976.71-3.885 1.998-5.371A8.024 8.024 0 0 1 9.71 2.088a7.977 7.977 0 0 1 5.524 1.303 8.144 8.144 0 0 1 3.304 4.666 8.235 8.235 0 0 1-.556 5.711 8.09 8.09 0 0 1-4.14 3.923 7.963 7.963 0 0 1-5.67.188 8.073 8.073 0 0 1-4.384-3.64m-1.079-4.074 2.525-2.037m-2.525 2.037L.811 7.605M10.6 5.51v4.645l3.344 3.345"
  })));
};
export default SvgHistory;